import React, { useEffect, useState } from "react";

const C4ModelIndex: React.FC = () => {
  const [html, setHtml] = useState("");

  useEffect(() => {
    const headers = {
    } as any;
    if (
      (localStorage.getItem('token') || '').length > 0
    ) {
      headers['Authorization'] = 'Bearer '.concat(
        (localStorage.getItem('token') || '')
      );
      headers['idempotent-key'] = localStorage.getItem('idempotent-key');
    }
    const fetchHtml = async () => {
      var host = process.env.REACT_APP_API_HOST;
      if(!host){
        host = window.location.origin;
      }
      const res = await fetch(`${host}/api/c4`, {
        headers: headers,
      });
      const text = await res.text();
      setHtml(text);
    };

    fetchHtml();
  }, []);

  return (
    <iframe
      title="C4 MODEL BAI ONLINE"
      srcDoc={html}
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  );
};

export default C4ModelIndex;
